import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import useIsDesktopLayout from '../useIsDesktopLayout';
import { recentLaunchedGamesSelector } from '../../redux/reducers/app/storage';
import { getAvailableGames } from '../../utils/collectionAdapters';
import { useQueryCategories } from './useQueryCategories';
import { useQueryProviders } from './useQueryProviders';
import { useQueryGamesByIds } from './useQueryGames';

// eslint-disable-next-line  no-unused-vars
const useQueryCommon = (games = [], queryOptions = {}) => {
  const isDesktop = useIsDesktopLayout();
  const queryCategories = useQueryCategories({ _limit: -1 }, queryOptions);
  const queryProviders = useQueryProviders({ _limit: -1 }, queryOptions);

  const isLoading = queryCategories.isLoading || queryProviders.isLoading;
  const isSuccess = queryCategories.isSuccess && queryProviders.isSuccess;

  const data = useMemo(() => {
    return isSuccess
      ? getAvailableGames({
          games,
          categories: queryCategories.data?.items,
          providers: queryProviders.data?.items,
          isDesktop,
        })
      : games;
  }, [games, isSuccess, queryCategories.data, queryProviders.data, isDesktop]);

  return {
    isLoading,
    isSuccess,
    data,
  };
};

const gameIdValidator = (id) => typeof id === 'string';

export const useQueryRecentLaunchedGames = (queryOptions = {}) => {
  const games = useSelector(recentLaunchedGamesSelector);
  const ids = games?.map((game) => game.id).filter(gameIdValidator);

  const select = (data) => {
    return data?.items?.filter((game) => game?.status === 'ACTIVE') || [];
  };

  return useQueryGamesByIds(ids, { select, ...queryOptions });
};
